var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "breadcrumbs" },
    [
      _vm._l(_vm.breadcrumbs, function(breadcrumb, index) {
        return [
          index + 1 < _vm.breadcrumbs.length
            ? [
                _c(
                  "a",
                  {
                    key: index,
                    staticClass: "breadcrumb",
                    attrs: { href: breadcrumb.link }
                  },
                  [_vm._v(_vm._s(breadcrumb.title))]
                ),
                _vm._v(" "),
                _c("span", {
                  key: index + "s",
                  staticClass: "separator",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.svg("chevron-right", "h-8 w-auto mt-4")
                    )
                  }
                })
              ]
            : [
                _c("span", { key: index, staticClass: "breadcrumb" }, [
                  _vm._v(_vm._s(breadcrumb.title))
                ])
              ]
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }